import {
  getWorkoutsBeforeDate,
  sumDurationOfWorkoutInMinutes,
  UserWorkoutSession,
} from 'fitbeat.gym-core';
import { GymTypes, TimeSpan } from 'fitbeat.models';
import moment from 'moment-timezone';
import { createSelector } from 'reselect';
import { IAppStore } from '../HomeWorkouts';
import { GymResolver } from '../services';

const getTotalMinScheduled = (state: IAppStore): number => {
  const timezone = moment.tz.guess();
  const endOfWeek = TimeSpan.getEndOfISOWeekInTimezone(new Date(), timezone);
  const workouts = state.planner.workoutSessions;

  const workoutsThisWeek = getWorkoutsBeforeDate(workouts, endOfWeek);
  return sumDurationOfWorkoutInMinutes(workoutsThisWeek);
};

export const getMinsScheduledSelector = createSelector(
  [getTotalMinScheduled],
  (scheduledMins) => scheduledMins,
);

const getNextWorkout = (state: IAppStore): UserWorkoutSession | undefined => state.planner.workoutSessions[0];

export const nextWorkoutSelector = createSelector(
  [getNextWorkout],
  (nextWorkout) => nextWorkout,
);

export const isNextWorkoutCheckedInStudioWorkoutSelector = createSelector(
  [getNextWorkout],
  (nextWorkout) => {
    if (!nextWorkout) {
      return false;
    }
    const gym = GymResolver.getByName(nextWorkout.gymName);
    if (gym.type !== GymTypes.Home) {
      return nextWorkout.checkedIn;
    }
    return false;
  },
);

export const currentActiveOrCheckedInWorkoutSelector = createSelector(
  [getNextWorkout],
  (nextWorkout): UserWorkoutSession | undefined => {
    if (!nextWorkout) {
      return undefined;
    }
    const now = new Date();
    const workoutIsInProgress = new Date(nextWorkout.startTime) < now && now < new Date(nextWorkout.endTime);
    if (workoutIsInProgress) {
      return nextWorkout;
    }

    const gym = GymResolver.getByName(nextWorkout.gymName);
    if (gym.type !== GymTypes.Home && nextWorkout.checkedIn) {
      return nextWorkout;
    }
    return undefined;
  },
);
